// AutoGenerated
import { HesapSarkiSesKayitNotlarModel } from "../businessModels/HesapSarkiSesKayitNotlarModel"

export class HesapKayitYorumRequestModel {
    constructor(
        hesapSarkiSesKayitId: string,
        uygun: boolean,
        yorum: string,
        resimIcerikId: string | null,
        orijinalPdfIcerikId: string | null,
        notlar: HesapSarkiSesKayitNotlarModel[],
    ) {
        this.hesapSarkiSesKayitId = hesapSarkiSesKayitId;
        this.uygun = uygun;
        this.yorum = yorum;
        this.resimIcerikId = resimIcerikId;
        this.orijinalPdfIcerikId = orijinalPdfIcerikId;
        this.notlar = notlar;
    }

    hesapSarkiSesKayitId: string;
    uygun: boolean;
    yorum: string;
    resimIcerikId: string | null;
    orijinalPdfIcerikId: string | null;
    notlar: HesapSarkiSesKayitNotlarModel[];
}